import React from 'react';
import { Construction, Wrench, Hammer, Sparkles } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import FloatingButtons from '../components/FloatingButtons';

const ComingSoonPage = ({ pageName = 'Esta Página' }) => {
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-50 via-white to-zinc-50">
      <Navigation isScrolled={isScrolled} />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          {/* Animated Construction Icons */}
          <div className="relative mb-12">
            <div className="flex justify-center items-center gap-8 mb-8">
              <div className="animate-bounce" style={{ animationDelay: '0s' }}>
                <Construction className="text-[#90EE90]" size={64} />
              </div>
              <div className="animate-bounce" style={{ animationDelay: '0.2s' }}>
                <Wrench className="text-zinc-700" size={56} />
              </div>
              <div className="animate-bounce" style={{ animationDelay: '0.4s' }}>
                <Hammer className="text-[#90EE90]" size={60} />
              </div>
            </div>
            
            {/* Sparkles */}
            <div className="absolute top-0 left-1/4 animate-ping">
              <Sparkles className="text-yellow-400" size={24} />
            </div>
            <div className="absolute top-8 right-1/4 animate-ping" style={{ animationDelay: '1s' }}>
              <Sparkles className="text-yellow-400" size={20} />
            </div>
          </div>

          {/* Main Message */}
          <h1 className="text-5xl md:text-7xl font-bold text-zinc-900 mb-6">
            ¡Estamos Construyendo
            <br />
            <span className="text-[#90EE90]">Algo Increíble!</span>
          </h1>

          <p className="text-xl text-zinc-600 mb-4">
            La sección <strong>{pageName}</strong> está en construcción
          </p>

          <p className="text-lg text-zinc-500 mb-12 max-w-2xl mx-auto">
            Nuestro equipo está trabajando arduamente para traerte contenido espectacular. 
            Mientras tanto, explora nuestras otras secciones o contáctanos directamente.
          </p>

          {/* Progress Bar Animation */}
          <div className="max-w-md mx-auto mb-12">
            <div className="bg-zinc-200 rounded-full h-4 overflow-hidden">
              <div className="bg-gradient-to-r from-[#90EE90] to-[#7CDF7C] h-full rounded-full animate-pulse" style={{ width: '65%' }}></div>
            </div>
            <p className="text-sm text-zinc-500 mt-2">Progreso del desarrollo: 65%</p>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/"
              className="bg-gradient-to-r from-[#90EE90] to-[#7CDF7C] text-zinc-900 px-8 py-4 rounded-xl font-bold hover:shadow-xl transition-all duration-300 inline-block"
            >
              Volver al Inicio
            </a>
            <a
              href="/calculadora"
              className="bg-zinc-900 text-white px-8 py-4 rounded-xl font-bold hover:bg-zinc-800 transition-all duration-300 inline-block"
            >
              Ir a Calculadora Solar
            </a>
          </div>

          {/* Fun Message */}
          <div className="mt-16 bg-[#90EE90]/10 border-2 border-[#90EE90] rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-zinc-900 mb-3">💚 ¿Quieres ser el primero en saberlo?</h3>
            <p className="text-zinc-700 mb-4">
              Contáctanos por WhatsApp y te avisaremos cuando esta sección esté lista
            </p>
            <a
              href="https://wa.me/595991344956?text=Hola%20Zenex!%20Me%20interesa%20saber%20cuando%20est\u00e9n%20listas%20las%20nuevas%20secciones"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#25D366] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#20BA5A] transition-all duration-300"
            >
              Contactar por WhatsApp
            </a>
          </div>
        </div>
      </div>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default ComingSoonPage;